import $ from 'jquery';
import 'slick-carousel'

// prettier-ignore
const videoSlider = () => {
    $(function() {
        var michelsPages = ['http://anwaelte.michels-legal.test/',
            'https://michels-inso.de/de/startseite/',
            'https://m-firm.de/de/startseite/',
            'http://www.michels-consulting.de/'
        ];
        var moreAnchor = $('a.more');

        var speed_ms = 3600; // hier wird die speed in millisekunden eingestellt
        var speed_s = speed_ms / 1000;


        // set the initial value
        $(moreAnchor).attr('href', michelsPages[0]);

        // init Video Container Slider for Desktop only
        if ($(window).width() > 375) {
            $('.dependance-slider-desktop').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: true,
                autoplaySpeed: speed_ms, // this should be 1/4 of video length in miliseconds, so that video content and slides change sync together
                dots: true,
                arrows: false,
                speed: 0,
                draggable: false
            });


            var video = $('#video1').get(0);

            function goToVideoAndSlide(currentTime, slideToGo) {
                video.currentTime = currentTime;
                $('.dependance-slider-desktop').slick('slickGoTo', slideToGo);
            }

            $('span.zero').on('click', function() {
                goToVideoAndSlide(0 * speed_s, 0);
            });
            $('span.three').on('click', function() {
                goToVideoAndSlide(1 * speed_s, 1);
            });
            $('span.six').on('click', function() {
                goToVideoAndSlide(2 * speed_s, 2);
            });
            $('span.nine').on('click', function() {
                goToVideoAndSlide(3 * speed_s, 3);
            });

            // change slides and jump to video content on slider dot(line) click
            $('.dependance-slider-desktop').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                video.currentTime = nextSlide * speed_s;

                // change href of the anchor depending on slide
                $(moreAnchor).attr('href', michelsPages[nextSlide]);
            });



        } else { // init dependance-slider-mobile
            $('.dependance-slider-mobile').slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                autoplay: false,
                dots: true,
                arrows: false,
                customPaging: function(slider, i) {
                    var thumb = $(slider.$slides[i]).data();
                    return '<a class="custom-dot">0' + (i + 1) + '</a>';
                },
            });
            $('.dependance-slider-mobile').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                // change href of the anchor depending on slide
                $(moreAnchor).attr('href', michelsPages[nextSlide]);
            });
        }
    });
};
export default videoSlider;


// WEBPACK FOOTER //
// ./src/scripts/modules/video-slider.js